import FunnelBuilder from './Index.vue';

export const routes = [
  {
    path: 'funil',
    name: 'talkvia_funnels',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: FunnelBuilder,
  },
];
